import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { shallowEqual } from 'react-redux';
import { useBreakpointValue } from 'utils/mediaQuery/useBreakpointValue';
import { pubSub } from 'utils/pubSub';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { Navigation } from './components/navigation/navigation';
import { TopBar } from './components/topBar/topBar';
import styles from './layoutContainer.module.scss';
/**
 * Represents the component where the layout of the agent interface and all its
 * routed views are rendered.
 */
export const LayoutContainer = ({ children, }) => {
    const { presence, profile } = useAppSelector((state) => ({
        presence: state.presence,
        profile: state.settings.profile.profile,
    }), shallowEqual);
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const handleToggleNavigation = () => {
        pubSub.publish('toggleNavigation', isSmallScreen ? {} : { isOpen: false });
    };
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx(Navigation, {}), _jsxs("main", Object.assign({ className: styles.main }, { children: [_jsx("div", Object.assign({ className: styles.mainTop }, { children: _jsx(TopBar, { onToggleNavigation: handleToggleNavigation }) })), _jsx("div", Object.assign({ className: styles.mainContainer }, { children: _jsx("div", Object.assign({ className: styles.mainContent, id: "content" }, { children: Children.map(children, (child) => {
                                return isValidElement(child)
                                    ? cloneElement(child, { profile, presence })
                                    : undefined;
                            }) })) }))] }))] })));
};
